export default __webpack_public_path__ + "static/media/earn-x33-coin-ico.167b5564.svg";